import KycDocsHistory from './KycDocsHistory';

export default KycDocsHistory;
